import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DepositCheckoutPage from '../components/deposit-checkout';
import * as depositActions from '../redux/actions/depositActions';
import * as catalogActions from '../redux/actions/catalogActions';

const mapStateToProps = (state) => ({
  depositReducer: state.depositReducer,
  catalog: state.catalogReducer,
});

const mapDispatchToProps = (dispatch) => ({
  depositActions: bindActionCreators(depositActions, dispatch),
  catalogActions: bindActionCreators(catalogActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DepositCheckoutPage);
